import React, { useState, useEffect } from 'react'
import { Translate } from '../../language';
import Button from '../../utils/components/Button/Button'
import TermsAndConditions from './TermsAndConditions';
import { CloseIcon } from '../../assets/icons';
import './ModalTermsAndConditions.css';

const ModalTermsAndConditions = ({ displayModal, closeModal, accepTerms, isAcceptTerms, isChecked }) => {

    const [showPanel, setShowPanel] = useState(1)

    const divStyle = {
        display: displayModal ? 'block' : 'none'
    };

    const close = (e) => {
        e.stopPropagation()
        closeModal(e)
    }

    return (
        <div
            className={"modal-terms"}
            onClick={close}
            style={divStyle} >
            <div
                className={`modal-terms-content`}
                onClick={e => e.stopPropagation()} >
                <div onClick={(e) => {
                    close(e)
                }} className="close-modal-terms">
                    <CloseIcon className="close-icon-terms" />
                </div>
                {/*   <div className="tap-modal-terms-terms">
                    <div onClick={() => setShowPanel(1)} className="tap-terms">Terminos y Condiciones</div>
                    <div onClick={() => setShowPanel(2)} className="tap-terms">Privacidad</div>
                </div> */}
                <div className="scroll-menu content-data-terms">
                    {showPanel === 1 && <TermsAndConditions />}
                    
                </div>
                <Button
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        isChecked()
                        close(e)
                    }}
                    text={Translate('accept', 'es')}
                    classNameContent={'button-accept-termns'}
                />
                <Button
                    onClick={(e) => {
                        e.stopPropagation();
                        close(e)
                    }}
                    text={Translate('reject', 'es')}
                    theme={'white'}
                    classNameContent={'button-accept-termns reject-button'}
                />
            </div>
        </div>
    );
}
export default ModalTermsAndConditions;